import { useEffect } from "react";

declare global {
    interface Window {
        soChatCustomerName?: string;
        soChatCustomerEmail?: string;
        soChatCompanyName?: string;
        SuperOffice_setupChat?: () => void;
        SuperOffice_chat_iframe?: HTMLIFrameElement | undefined;
        SuperOffice_chat_mobileFullsize?: boolean;
    }
}

type User = {
    name: string;
    email: string;
    companyName?: string;
};

export function SuperOfficeChatBootstrap({ user }: { user: User | null }) {
    useEffect(() => {
        if (!user) {
            // Remove chat if it exists when user is logged out
            const chatDiv = document.getElementById("SuperOffice_chatdiv");
            if (chatDiv && chatDiv.parentNode) {
                chatDiv.parentNode.removeChild(chatDiv);
            }

            window.SuperOffice_chat_iframe = undefined;
            window.SuperOffice_chat_mobileFullsize = false;

            window.soChatCustomerName = "";
            window.soChatCustomerEmail = "";
            window.soChatCompanyName = "";
            return;
        }

        window.soChatCustomerName = user.name;
        window.soChatCustomerEmail = user.email;
        window.soChatCompanyName = user.companyName ?? "";

        const alreadyInitialized = !!document.getElementById("SuperOffice_chatdiv");
        if (alreadyInitialized) return;

        if (typeof window.SuperOffice_setupChat === "function") {
            window.SuperOffice_setupChat();
        }
    }, [user?.name, user?.email, user?.companyName]);

    return null;
}
